import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: {
          General: "General",
          "Dashboards, Widgets": "Dashboards, Widgets",
          Dashboard: "Dashboard",
          Subscription: "Subscription",
          Plans: "Plans",
          "Add/Edit": "Add/Edit",
          Subscribers: "Subscribers",
          Classes: "Classes",
          Products: "Products",
          Marketing: "Marketing",
        },
      },
      cn: {
        translations: {
          General: "一般",
          "Dashboards, Widgets": "仪表板, 小部件",
          Dashboard: "仪表板",
          Subscription: "订阅",
          Plans: "计划",
          "Add/Edit": "添加/编辑",
          Subscribers: "订阅者",
          Classes: "课程",
          Products: "产品",
          Marketing: "营销",
        },
      },
      ae: {
        translations: {
          General: "عام",
          "Dashboards, Widgets": "لوحات القيادة, الحاجيات",
          Dashboard: "لوحة القيادة",
          Subscription: "الاشتراك",
          Plans: "الخطط",
          "Add/Edit": "إضافة/تحرير",
          Subscribers: "المشتركون",
          Classes: "الفصول الدراسية",
          Products: "المنتجات",
          Marketing: "التسويق",
        },
      },
      du: {
        translations: {
          General: "Algemeen",
          "Dashboards, Widgets": "Dashboards, Widgets",
          Dashboard: "Dashboard",
          Subscription: "Abonnement",
          Plans: "Plannen",
          "Add/Edit": "Toevoegen/Bewerken",
          Subscribers: "Abonnees",
          Classes: "Klassen",
          Products: "Producten",
          Marketing: "Marketing",
        },
      },
      es: {
        translations: {
          General: "General",
          "Dashboards, Widgets": "Cuadros de mando, Widgets",
          Dashboard: "Tablero",
          Subscription: "Suscripción",
          Plans: "Planes",
          "Add/Edit": "Agregar/Editar",
          Subscribers: "Suscriptores",
          Classes: "Clases",
          Products: "Productos",
          Marketing: "Marketing",
        },
      },
      fr: {
        translations: {
          General: "Général",
          "Dashboards, Widgets": "Tableaux de bord, Widgets",
          Dashboard: "Tableau de bord",
          Subscription: "Abonnement",
          Plans: "Plans",
          "Add/Edit": "Ajouter/Modifier",
          Subscribers: "Abonnés",
          Classes: "Cours",
          Products: "Produits",
          Marketing: "Marketing",
        },
      },
      pt: {
        translations: {
          General: "Geral",
          "Dashboards, Widgets": "Painéis, Widgets",
          Dashboard: "Painel de Controle",
          Subscription: "Assinatura",
          Plans: "Planos",
          "Add/Edit": "Adicionar/Editar",
          Subscribers: "Assinantes",
          Classes: "Aulas",
          Products: "Produtos",
          Marketing: "Marketing",
        },
      },
    },
    fallbackLng: "en",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
